import { Component, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { EdlCfGenericComponent } from '@edl-development/edl-custom-forms';
import { PaetepCfSignatureModel } from '../../../item-models/paetep-cf-signature.model';
import { PaetepCfAnswerSignatureModel } from '../../../answer-models/paetep-cf-answer-signature.model';
import { Subscription, firstValueFrom } from 'rxjs';
import { CustomFormsSharedDataService } from '../../services/custom-forms-shared-data/custom-forms-shared-data.service';
import { CustomFormsService } from 'src/app/services/Observation/custom-forms/custom-forms.service';
import { ToastrService } from 'ngx-toastr';
import { CustomFormSignatureType } from 'src/app/model/enum/observations/custom-forms/custom-form-signature-type.enum';
import { SessionService } from '@edl-development/edl-common';

@Component({
    selector: 'paetep-cf-display-signature',
    templateUrl: './paetep-cf-display-signature.component.html',
    styleUrls: ['./paetep-cf-display-signature.component.scss'],
    viewProviders: [{
        provide: ControlContainer,
        useFactory: (container: ControlContainer) => container,
        deps: [[new SkipSelf(), ControlContainer]]
    }]
})
export class PaetepCfDisplaySignatureComponent extends EdlCfGenericComponent<PaetepCfSignatureModel, PaetepCfAnswerSignatureModel> implements OnInit, OnDestroy {

    private subscription?: Subscription;
    public signatureDate?: Date;
    public signatureName?: string;

    constructor(
        private container: ControlContainer,
        private customFormsSharedDataService: CustomFormsSharedDataService,
        private customFormService: CustomFormsService,
        private toastrService: ToastrService,
        private sessionService: SessionService
    ) { 
        super();
    }

    ngOnInit(): void {
        this.signatureName = this.answer?.value?.signatureName;
        this.signatureDate = this.answer?.value?.signatureDate;

        this.subscription = this.container.control?.get('answer')?.valueChanges.subscribe((value) => {
            if (this.customFormsSharedDataService.userForm) {
                const userFormId = this.customFormsSharedDataService.userForm.userFormId;
                const questionId = this.model.id;

                !!value ? this.sign(userFormId, questionId) : this.removeSignature(userFormId, questionId);
            }
        })
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    getSignatureTypeLabel = () => {
        switch (this.model.config.option) {
            case CustomFormSignatureType.ADMIN:
                return 'Administrator';
            case CustomFormSignatureType.SUPERVISOR:
                return 'Supervisor';
            case CustomFormSignatureType.TARGET_USER:
            default:
                return 'Employee';
        }
    }

    private sign = (userFormId: string, questionId: string) => {
        firstValueFrom(
            this.customFormService.signUserForm(userFormId, questionId)
        ).then(() => {
            this.signatureDate = new Date();
            this.signatureName = this.sessionService.user?.DisplayName;

            this.toastrService.success('Signature added successfully.');
        })
    }

    private removeSignature = (userFormId: string, questionId: string) => {
        firstValueFrom(
            this.customFormService.removeSignatureUserForm(userFormId, questionId)
        ).then(() => {
            this.signatureDate = undefined;
            this.signatureName = undefined;
            this.toastrService.success('Signature removed successfully.');
        })
    }

}
